import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import { StatusManager } from 'common/components/StatusManager';
import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';

import { ROLEPLAY_FEEDBACK_STATUSES } from '../constants';

import { useStyles } from './RoleplayPresentation.styled';

const COPIES = strings.ai.generators.roleplay.feedbackDrawer.tabs.presentation;

export const RoleplayPresentation = ({ callId }) => {
  const classes = useStyles();
  const { refreshData, state } = useFetchWithStatusV2({
    apiInstance: SECONDARY_API_CLIENT,
    endpoint: `${AI_ENDPOINTS.roleplayCallDetails.replace(':id', callId)}`
  });

  const data = state?.results || {};
  const isCompleted = data?.status?.id === ROLEPLAY_FEEDBACK_STATUSES.completed;

  const presentationText = data?.presentationText || null;

  return (
    <StatusManager
      status={state.status}
      slots={{
        Error: <EmptyPlaceholder title={COPIES.error} subtitle={state.error} />,
        Loading: (
          <Box alignItems="center" display="flex" height="100%" justifyContent="center">
            <CircularProgress />
          </Box>
        )
      }}
    >
      {isCompleted ? (
        <Box display="flex" flexDirection="column" gridGap={36} p={3}>
          <Box display="flex" flexDirection="column" gridGap={20}>
            <Typography variant="subtitle1">{COPIES.title}</Typography>

            <Typography className={classes.presentationText} variant="body2">
              {presentationText || COPIES.noPresentation}
            </Typography>
          </Box>
        </Box>
      ) : (
        <EmptyPlaceholder title={COPIES.emptyState.title} subtitle={COPIES.emptyState.subtitle}>
          <Button color="primary" onClick={refreshData} startIcon={<RefreshOutlinedIcon />}>
            {COPIES.emptyState.actionButton}
          </Button>
        </EmptyPlaceholder>
      )}
    </StatusManager>
  );
};
